import * as angular from 'angular';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import UserProfileName, {UserProfile} from "../../models/userProfile";
import UserServiceName, {UserService} from "../../services/users/user.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import * as _ from "lodash";
import template from "./userProfile.tpl.html";
import ChangeUserPasswordName, {openChangeUserPassword} from "./changeUserPassword.controller";
import isNullOrUndefined from "../../services/utility/isNullOrUndefined";

let requires = [LoaderServiceName, NotifyServiceName, UserProfileName, UserServiceName, ChangeUserPasswordName];

export interface UserProfileController {
  form?: angular.IFormController;

  userName: string;
  user: apsViewModels.UserProfileData;
  securityQuestion: apsViewModels.SecurityQuestionItem;
  securityAnswer: string;
  defectDisplay: string;

  securityQuestions:apsViewModels.SecurityQuestionItem[];
  defectDisplayOptions: string[];

  save():void;
  close():void;
  changePassword():void;
}

export function openUserProfile($modal: mm.foundation.modal): mm.foundation.modalInstance {
  return $modal.open({
    template: template,
    controller: 'UserProfileCtrl as vm'
  });
}

export default angular.module('aps.controller.userProfile', requires)
  .controller('UserProfileCtrl', userProfileCtrl)
  .name;

function userProfileCtrl($modalInstance: mm.foundation.modalInstance,
                         $modal: mm.foundation.modal,
                         loaderService: LoaderService,
                         notifyService: NotifyService,
                         userProfile: UserProfile,
                         userService: UserService) {
  let vm = this as UserProfileController;

  vm.defectDisplayOptions = ['By Abbreviation', 'By Number'];
  vm.securityQuestions = [];
  vm.user = undefined;

  let numberFormat = () => {
    let phoneNumber = vm.user.phoneNumber;
    if ((phoneNumber || '') === '') {
      return;
    }

    if (phoneNumber.length > 7) {
      phoneNumber = '(' + phoneNumber.substr(0, 3) + ') ' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
    } else {
      phoneNumber = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3);
    }
    vm.user.phoneNumber = phoneNumber;
  };

  let promise = userProfile.read().then(userData => {
    vm.user = userData;
    vm.user.displayDefectsByNumber = isNullOrUndefined(userData.displayDefectsByNumber)
      ? true : userData.displayDefectsByNumber;
    vm.defectDisplay = vm.defectDisplayOptions[(vm.user.displayDefectsByNumber ? 1 : 0)];
    vm.userName = vm.user.userName;
    numberFormat();

    return userService.getSecurityQuestions().then(questions => {
      vm.securityQuestions = questions;
      if (vm.user.securityQuestion) {
        vm.securityQuestion = _.find(vm.securityQuestions, {question: vm.user.securityQuestion});
      }
    });
  });

  loaderService.loadingPromise(promise);

  vm.save = () => {
    vm.user.displayDefectsByNumber = (vm.defectDisplayOptions.indexOf(vm.defectDisplay) > 0);
    let saveData: apsCommands.EditUserProfile = {
      id: vm.user.id,
      email: vm.user.email,
      phoneNumber: vm.user.phoneNumber,
      securityQuestionId: undefined,
      securityAnswer: undefined,
      displayDefectsByNumber: vm.user.displayDefectsByNumber
    };
    if (vm.securityQuestion) {
      saveData.securityQuestionId = vm.securityQuestion.id;
      saveData.securityAnswer = (vm.securityAnswer || '').toString().toLowerCase();
    }
    if (!saveData.email) {
      saveData.email = undefined;
    }
    if (saveData.phoneNumber) {
      saveData.phoneNumber = saveData.phoneNumber.replace(/\D/g, '');
    } else {
      saveData.phoneNumber = undefined;
    }

    loaderService.loadingPromise(
      userService.saveUserProfile(saveData).then(() => {
        notifyService.success('Saved', 'User Profile');
        userProfile.updateEditProfile(saveData);
        $modalInstance.close();
      }, notifyService.handleApiErrors));
  };

  vm.close = () => {
    $modalInstance.close();
  };

  vm.changePassword = () => {
    openChangeUserPassword(vm.user, $modal);
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/userProfile/userProfile.controller.ts